import { getIdFromUrl } from 'vue-youtube';
import { faker } from '@faker-js/faker';
import { formatToChartData } from '../../utils';
import { FAKE_DATA } from './data';

const TOKEN = 'fd6f8805-3641-554f-b1ab-36d85d79597f';

const VIDEO_DESCRIPTION = `After standing down from launch on Wednesday, May 27, SpaceX is now targeting Saturday, May 30 for Falcon 9’s launch of Crew Dragon’s second demonstration (Demo-2) mission from Launch Complex 39A (LC-39A) at NASA’s Kennedy Space Center in Florida. This test flight with NASA astronauts Bob Behnken and Doug Hurley on board the Dragon spacecraft will return human spaceflight to the United States.

The instantaneous launch window opens at 3:22 p.m. EDT, or 19:22 UTC, with a backup instantaneous launch opportunity available on Sunday, May 31 at 3:00 p.m. EDT, or 19:00 UTC. Tune in here to watch the launch webcast. Coverage will begin about 4 hours before liftoff.

Demo-2 is the final major test for SpaceX’s human spaceflight system to be certified by NASA for operational crew missions to and from the International Space Station. SpaceX is returning human spaceflight to the United States with one of the safest, most advanced systems ever built, and NASA’s Commercial Crew Program is a turning point for America’s future in space exploration that lays the groundwork for future missions to the Moon, Mars, and beyond.`;

const STORAGE_KEYS = {
  profile: 'api-vidoes',
  videos: 'api-videos',
  folders: 'api-folders',
};

const USER = {
  email: 'bawibovu@im.hr',
  name: 'Adam Weber',
  id: 100,
};

const getVideoData = (data) => {
  const description = data.description || this.description;
  return {
    ...data,
    category: 'space',
    image: data.image || 'http://img.youtube.com/vi/rjb9FdVdX5I/maxresdefault.jpg',
    topic: 'spacecraft',
    description,
    length: `${String(faker.datatype.number(24)).padStart(2, '0')}:${String(faker.datatype.number(60)).padStart(
      2,
      '0',
    )}`,
    production_owerview: {
      method: 'lecture',
      value: faker.datatype.number(10),
      on_camera_location: 'indoors',
      on_camera_gender: 'male',
      on_camera_race: 'white',
      on_camera_age: faker.datatype.number(50) + 10,
      faces_on_camera: faker.datatype.number(1),
      numbers_of_shots_changes: faker.datatype.number(5),
    },
    transcript_overview: {
      title_length: data.name.split(' ').length,
      description_length: description.split(' ').length,
      transcript_length: faker.datatype.number(1500) + 500,
      keywords_in_title: data.name.replace('.', '').replace(',', '').split(' '),
      keywords_in_description: description
        .replace('.', '')
        .replace(',', '')
        .split(' ')
        .filter((item, idx) => idx % 2),
      most_used_keywords: data.name.replace('.', '').replace(',', '').split(' '),
      is_sponsored: true,
    },
    language_stats: {
      words_count: faker.datatype.number(1500) + 500,
      commonly_used_words: data.name.replace('.', '').replace(',', '').split(' '),
      objects: String(faker.lorem.words(5) + 2).split(' '),
      sponsors: true,
      proper_nouns: String(faker.lorem.words(5) + 2).split(' '),
    },
  };
};

const saveProfile = (email) => {
  const profile = {
    ...USER,
    email: email || USER.email,
    city: faker.address.city(),
    country: faker.address.country(),
    address: faker.address.streetAddress(),
    company: faker.company.companyName(),
    avatar: faker.image.avatar(),
    role: 'user',
    created_at: faker.date.between(2010, 2019),
    last_password_change: faker.date.past(),
  };
  localStorage.setItem('profile', JSON.stringify(profile));
  return profile;
};

export class Http {
  login = async ({ email }) => {
    saveProfile(email);

    return { ...USER, email, token: TOKEN };
  };

  getProfile = async () => {
    const cachedProfile = localStorage.getItem(STORAGE_KEYS.profile);

    if (cachedProfile) {
      return JSON.parse(cachedProfile);
    }

    return saveProfile();
  };

  getCatalog = async () => {
    try {
      const videos = localStorage.getItem(STORAGE_KEYS.videos);
      if (videos) {
        return JSON.parse(videos);
      }

      const data = FAKE_DATA.videos.map((item) => ({
        image: `https://picsum.photos/id/${faker.datatype.number(1000) + 1}/1280/960`,
        date: faker.date.between(2010, 2020),
        ...getVideoData(item),
      }));

      const shallowCopy = data.map((item) => ({
        ...item,
        videoId: getIdFromUrl(item?.link),
      }));
      localStorage.setItem(STORAGE_KEYS.videos, JSON.stringify(shallowCopy));
      return shallowCopy;
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  getVideoDetails = async (id) => {
    try {
      const videos = await this.getCatalog();
      const data = videos.find((item) => item.id === id);
      data.videoId = getIdFromUrl(data?.link);
      return { ...data, date: faker.date.between(2010, 2020), ...getVideoData(data) };
    } catch {
      return null;
    }
  };

  deleteVideo = async (id) => {
    try {
      const videos = await this.getCatalog();
      const idx = videos.findIndex((item) => item.id === id);
      if (idx >= 0) {
        videos.splice(idx, 1);
        localStorage.setItem(STORAGE_KEYS.videos, JSON.stringify(videos));
        return videos;
      }
      return null;
    } catch {
      return null;
    }
  };

  addVideo = async (body) => {
    try {
      const data = {
        ...body,
        image: `https://picsum.photos/id/${faker.datatype.number(1000) + 1}/1280/960`,
        name: 'Crew Demo-2',
        description: body?.description || VIDEO_DESCRIPTION,
        date: faker.date.past(2020),
        impressions: faker.datatype.number(999999),
        views: faker.datatype.number(999999999),
        likes: faker.datatype.number(99999),
        dislikes: faker.datatype.number(9999),
        comments: faker.datatype.number(9999),
        engagement_ratio: faker.datatype.number(99),
        watch_time: `${faker.datatype.number(20)}:${faker.datatype.number(60)}`,
        watch_time_ratio: faker.datatype.number(99),
        click_through_rate: `1.${faker.datatype.number(99999)}`,
        ad_revenue: faker.datatype.number(9999),
        production_cost: faker.datatype.number(9999),
        roi: `${faker.datatype.number(99)}.${faker.datatype.number(9999)}`,
      };
      const videos = await this.getCatalog();
      videos.push(data);
      localStorage.setItem(STORAGE_KEYS.videos, JSON.stringify(videos));
      return data;
    } catch {
      return null;
    }
  };

  getAccounts = async () => [
    {
      id: 1,
      name: faker.internet.userName(),
      link: 'https://www.youtube.com/user/Wylsacom',
      thumbnail: 'https://yt3.ggpht.com/a/AATXAJzxiZYtwI4Gpt7JGZQ-9gQTIydFwZZQHSsczA=s176-c-k-c0x00ffffff-no-rj-mo',
      email: faker.internet.email(),
      owner: `${faker.name.firstName()} ${faker.name.lastName()}`,
    },
    {
      id: 2,
      name: faker.internet.userName(),
      link: 'https://www.youtube.com/user/rozetked',
      thumbnail: 'https://yt3.ggpht.com/a/AATXAJz-qSRkQJSZzVA4JQmrg1XPClRYrYXd52gKpQ=s88-c-k-c0x00ffffff-no-rj',
      email: faker.internet.email(),
      owner: `${faker.name.firstName()} ${faker.name.lastName()}`,
    },
  ];

  getCharts = async () => {
    try {
      const data = {
        watch_time: {
          '2020-01-01': faker.datatype.number(10) + 1,
          '2020-01-15': faker.datatype.number(10) + 2,
          '2020-02-01': faker.datatype.number(10 + 12) + 12,
          '2020-02-15': faker.datatype.number(10 + 12) + 12,
          '2020-03-01': faker.datatype.number(10 + 24) + 34,
          '2020-03-15': faker.datatype.number(10 + 24) + 34,
          '2020-04-01': faker.datatype.number(10 + 64) + 64,
          '2020-04-15': faker.datatype.number(10 + 64) + 64,
          '2020-05-01': faker.datatype.number(10 + 128) + 128,
          '2020-05-15': faker.datatype.number(10 + 64) + 64,
        },
        like_count: {
          '2020-01-01': faker.datatype.number(2000) + 1000,
          '2020-01-15': faker.datatype.number(2000) + 1000,
          '2020-02-01': faker.datatype.number(6000) + 3000,
          '2020-02-15': faker.datatype.number(6000) + 3000,
          '2020-03-01': faker.datatype.number(12000) + 6000,
          '2020-03-15': faker.datatype.number(12000) + 6000,
          '2020-04-01': faker.datatype.number(36000) + 18000,
          '2020-04-15': faker.datatype.number(36000) + 18000,
          '2020-05-01': faker.datatype.number(100000) + 54000,
          '2020-05-15': faker.datatype.number(100000) + 54000,
        },
        impression_count: {
          '2020-01-01': faker.datatype.number(2000) + 1000 + 1000,
          '2020-01-15': faker.datatype.number(2000) + 1000 + 1000,
          '2020-02-01': faker.datatype.number(6000) + 3000 + 1000,
          '2020-02-15': faker.datatype.number(6000) + 3000 + 1000,
          '2020-03-01': faker.datatype.number(12000) + 6000 + 1000,
          '2020-03-15': faker.datatype.number(12000) + 6000 + 1000,
          '2020-04-01': faker.datatype.number(36000) + 18000 + 1000,
          '2020-04-15': faker.datatype.number(36000) + 18000 + 1000,
          '2020-05-01': faker.datatype.number(100000) + 54000 + 1000,
          '2020-05-15': faker.datatype.number(100000) + 54000 + 1000,
        },
        ad_revenue: {
          '2020-01-01': faker.datatype.number(20000) + 10000,
          '2020-01-15': faker.datatype.number(20000) + 10000,
          '2020-02-01': faker.datatype.number(60000) + 30000,
          '2020-02-15': faker.datatype.number(60000) + 30000,
          '2020-03-01': faker.datatype.number(120000) + 60000,
          '2020-03-15': faker.datatype.number(120000) + 60000,
          '2020-04-01': faker.datatype.number(360000) + 180000,
          '2020-04-15': faker.datatype.number(360000) + 180000,
          '2020-05-01': faker.datatype.number(1000000) + 540000,
          '2020-05-15': faker.datatype.number(1000000) + 540000,
        },
      };
      const payload = {
        watchTime: formatToChartData(data.watch_time),
        likeCount: formatToChartData(data.like_count),
        impressionCount: formatToChartData(data.impression_count),
        adRevenue: formatToChartData(data.ad_revenue),
      };
      return payload;
    } catch {
      return null;
    }
  };

  getFolders = async () => {
    try {
      const folders = localStorage.getItem(STORAGE_KEYS.folders);
      if (folders) {
        return JSON.parse(folders);
      }
      localStorage.setItem(STORAGE_KEYS.folders, JSON.stringify(FAKE_DATA.folders));
      return FAKE_DATA.folders;
    } catch {
      return null;
    }
  };

  addFolder = async ({ name, videos = null }) => {
    try {
      const folders = await this.getFolders();
      folders.push({ name, videos, id: faker.datatype.uuid() });
      localStorage.setItem(STORAGE_KEYS.folders, JSON.stringify(folders));
      return folders;
    } catch {
      return null;
    }
  };

  deleteFolder = async (id) => {
    try {
      const folders = await this.getFolders();
      const idx = folders.findIndex((item) => item.id === id);
      if (idx >= 0) {
        folders.splice(idx, 1);
        localStorage.setItem(STORAGE_KEYS.folders, JSON.stringify(folders));
        return folders;
      }
      return null;
    } catch {
      return null;
    }
  };

  editFolder = async ({ id, ...body }) => {
    try {
      const folders = await this.getFolders();
      const idx = folders.findIndex((item) => item.id === id);
      if (idx >= 0) {
        folders.splice(idx, 1, { ...folders[idx], ...body });
        localStorage.setItem(STORAGE_KEYS.folders, JSON.stringify(folders));
        return folders[idx];
      }
      return null;
    } catch {
      return null;
    }
  };

  getClips = async () => {
    const getShot = (idx) => {
      const start = faker.datatype.number(2600) + 100;
      return {
        id: String(idx + 1),
        image: `https://picsum.photos/id/${faker.datatype.number(1000) + 1}/1280/960`,
        start,
        end: start + 1000,
        name: faker.lorem.words(faker.datatype.number(2) || 1),
        ad: faker.random.boolean() && !!(idx % 2),
      };
    };
    return [...new Array(60).keys()].map(getShot);
  };

  getShots = async () => {
    const getShot = (idx) => ({
      id: String(idx + 1),
      image: `https://picsum.photos/id/${faker.datatype.number(1000) + 1}/1280/960`,
      time: faker.datatype.number(3600) + 100,
    });

    return [...new Array(20).keys()].map(getShot);
  };
}

export default new Http();
